<template>
  <div class="text-14px grid 
              grid-cols-[28fr_20fr_18fr_20fr_25fr_12fr_16fr] 
              lg:grid-cols-[43fr_25fr_24fr_34fr_35fr_22fr_24fr] 
              rounded-8px bg-gray-600 mt-2">
    <div class='py-4 break-words rounded-8px relative max-w-1/5' :class="{ 'truncate': item.post.visible }">
      <template v-if="item.post.discarded_at">
        <div class="flex justify-center">
          <nav-panel type="warning" class="model-discarded-hint">
            {{ $t('profiles.model_discarded_hint.model_has_deleted') }}
          </nav-panel>
        </div>
      </template>
      <template v-else>
        <div v-if="item.post.verified_state === 'completed'" 
             class="w-4 h-4 flex items-center justify-center absolute top-0 bg-red rounded-tl-md rounded-br-md text-14px bg-[#E60044]">
          <img src="../../images/home/phrozen_verified.svg" class="w-3 h-2.5 brightness-[4]" />
        </div>
        <a :href="item.post.visible ? `/posts/${item.post.id}` : `/preview/posts/${item.post.id}`"
           class="px-2 hover:underline">
           {{ truncateText(item.post.title, 70) }}
        </a>
      </template>
    </div>
    
    <div class='py-4'>{{ formatDate(item.updated_at) }}</div>
    <div class='py-4'>{{ formatCurrency(item.order_item_price) }}</div>
    <div class='py-4'>{{ formatCurrency(item.commission_price) }}</div>
    <div class='py-4'>{{ formatCurrency(item.pv_commission_price) }}</div>
    <div class='py-4'>{{ formatCurrency(item.price) }}</div>
    <div class='flex items-center lg:justify-center xl:justify-start py-2'>
      <span class="rounded-3xl px-2 py-0.5 text-12px border h-6"
              :style="getPaymentStateStyle(item.payout_state)">
            {{ item.payout_state }}
        </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({  
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  
  methods: {
    truncateText(text, length) {
      return text.length > length ? text.substring(0, length) + '...' : text;
    },
    
    formatDate(date) {
      return new Date(date).toLocaleDateString('zh-TW', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/\//g, '-');
    },
    
    formatCurrency(amount) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    },
    
    getPaymentStateStyle(state) {
      return {
        color: `var(--color-payout-state-${state.toLowerCase()})`,
        background: `color-mix(in srgb, var(--color-payout-state-${state.toLowerCase()}), transparent 80%)`,
        borderColor: `var(--color-payout-state-${state.toLowerCase()})`
      };
    }
  }
});
</script>